import BeforeAfter from "../../components/before-after/BeforeAfter";

const BeforeAfterView = () => {

    return (
        <div className="before-after">
            <BeforeAfter/>
        </div>
    );
};

export default BeforeAfterView;